webpackJsonp([23,47],{

/***/ 1367:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1405:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
		value: true
});

var _css = __webpack_require__(27);

var _button = __webpack_require__(26);

var _button2 = _interopRequireDefault(_button);

var _css2 = __webpack_require__(30);

var _icon = __webpack_require__(20);

var _icon2 = _interopRequireDefault(_icon);

var _css3 = __webpack_require__(24);

var _modal = __webpack_require__(23);

var _modal2 = _interopRequireDefault(_modal);

var _css4 = __webpack_require__(14);

var _input = __webpack_require__(15);

var _input2 = _interopRequireDefault(_input);

var _css5 = __webpack_require__(17);

var _message = __webpack_require__(16);

var _message2 = _interopRequireDefault(_message);

var _css6 = __webpack_require__(22);

var _form = __webpack_require__(21);

var _form2 = _interopRequireDefault(_form);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(2);

var _login = __webpack_require__(554);

var _login2 = _interopRequireDefault(_login);

var _getMobileCode2 = __webpack_require__(574);

var _getMobileCode3 = _interopRequireDefault(_getMobileCode2);

var _queryString = __webpack_require__(53);

var _queryString2 = _interopRequireDefault(_queryString);

var _config = __webpack_require__(11);

var _Captcha = __webpack_require__(396);

var _Captcha2 = _interopRequireDefault(_Captcha);

var _forgetPasswordForm = __webpack_require__(628);

var _forgetPasswordForm2 = _interopRequireDefault(_forgetPasswordForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FormItem = _form2.default.Item;

var NormalLoginForm = function (_Component) {
		_inherits(NormalLoginForm, _Component);

		function NormalLoginForm(props) {
				_classCallCheck(this, NormalLoginForm);

				var _this = _possibleConstructorReturn(this, _Component.call(this, props));

				_this.showModal = function () {
						_this.setState({ visible: true });
				};

				_this.handleCancel = function () {
						_this.setState({ visible: false });
				};

				_this.handleCloseMobileCodeModal = function () {
						_this.setState({ mobileCodeVisible: false });
				};

				_this.handleSubmit = function (e) {
						e.preventDefault();
						_this.props.form.validateFields(function (err, values) {
								var userName = values.userName,
								    password = values.password,
								    mobileCode = values.mobileCode;
								var _this$props = _this.props,
								    redirect_uri = _this$props.redirect_uri,
								    client_id = _this$props.client_id,
								    state = _this$props.state;

								var params = {
										userName: btoa(userName),
										password: btoa(password),
										mobileCode: btoa(mobileCode),
										redirect_uri: redirect_uri,
										client_id: client_id,
										state: state
								};
								if (!err) {
										_this.props.authorizationLogin(params).then(function (_ref) {
												var retCode = _ref.retCode,
												    retMsg = _ref.retMsg,
												    retData = _ref.retData;

												if (retCode === _config.API_CODE_SUCCESS) {
														var _params = _queryString2.default.parse(location.search);
														_message2.default.success(retMsg, _config.CLOSE_TIME, function () {
																if (typeof retData.url !== 'undefined') {
																		location.href = retData.url;
																}
														});
												} else {
														_message2.default.error(retMsg, _config.CLOSE_TIME);
												}
										});
								}
						});
				};

				_this.handleGetMobileCode = function (e) {
						e.preventDefault();
						_this.props.form.validateFields(function (err, values) {
								var userName = values.userName,
								    password = values.password,
								    _values$captcha = values.captcha,
								    captcha = _values$captcha === undefined ? '' : _values$captcha;

								if (!err) {
										_this.props.getMobileCode({
												userName: btoa(userName),
												password: btoa(password),
												captcha: captcha
										}).then(function (_ref2) {
												var retCode = _ref2.retCode,
												    retMsg = _ref2.retMsg;

												if (retCode === _config.API_CODE_SUCCESS) {
														// 弹出 modal 手机验证码
														_this.setState({
																mobileCodeVisible: true
														});
												} else if (retCode == '80001') {
														var _this$props2 = _this.props,
														    redirect_uri = _this$props2.redirect_uri,
														    client_id = _this$props2.client_id,
														    state = _this$props2.state;

														var params = {
																userName: btoa(userName),
																password: btoa(password),
																redirect_uri: redirect_uri,
																client_id: client_id,
																state: state
														};
														_this.props.authorizationLogin(params).then(function (_ref3) {
																var retCode = _ref3.retCode,
																    retMsg = _ref3.retMsg,
																    retData = _ref3.retData;

																if (retCode === _config.API_CODE_SUCCESS) {
																		_message2.default.success(retMsg, _config.CLOSE_TIME, function () {
																				if (typeof retData.url !== 'undefined') {
																						location.href = retData.url;
																				}
																		});
																} else {
																		_message2.default.error(retMsg, _config.CLOSE_TIME);
																}
														});
												} else {
														_this.setState({ isReSet: Math.floor(Math.random() * (999 - 1) + 1) });
														if (retCode == '10005' || retCode == '30003') {
																_message2.default.error(retMsg, _config.CLOSE_TIME);
																_this.setState({ showCaptcha: true });
														} else {
																_message2.default.error(retMsg, _config.CLOSE_TIME);
														}
												}
										});
								}
						});
				};

				_this.state = {
						showCaptcha: false,
						isReSet: '',
						visible: false,
						mobileCodeVisible: false
				};
				return _this;
		}

		// 登录请求


		/***
   * 获取验证码逻辑：
   * 先根据用户名，密码 获取手机验证码 如果密码错误，则出现图片验证码；
   * 拿到手机验证码之后，再根据验证码，用户，密码登录OA
   */


		NormalLoginForm.prototype.render = function render() {
				var getFieldDecorator = this.props.form.getFieldDecorator;
				var showCaptcha = this.state.showCaptcha;


				return _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
								_form2.default,
								{ onSubmit: this.handleGetMobileCode, className: 'login-form' },
								_react2.default.createElement(
										_modal2.default,
										{
												title: '\u5DF2\u5411\u5F53\u524D\u8D26\u53F7\u6240\u7ED1\u5B9A\u624B\u673A\u53F7\u53D1\u9001\u9A8C\u8BC1\u7801\uFF0C\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801\u6821\u9A8C',
												visible: this.state.mobileCodeVisible,
												onOk: this.handleSubmit,
												onCancel: this.handleCloseMobileCodeModal,
												maskClosable: false
										},
										_react2.default.createElement(
												FormItem,
												{ label: '\u9A8C\u8BC1\u7801' },
												getFieldDecorator('mobileCode', {
														rules: [{
																required: this.state.mobileCodeVisible,
																message: '请输入验证码'
														}]
												})(_react2.default.createElement(_input2.default, {
														size: 'large',
														style: { width: 280 },
														placeholder: '\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801'
												}))
										)
								),
								_react2.default.createElement(
										FormItem,
										null,
										getFieldDecorator('userName', {
												rules: [{ required: true, message: '请输入用户名!' }]
										})(_react2.default.createElement(_input2.default, { prefix: _react2.default.createElement(_icon2.default, { type: 'user', style: { fontSize: 13 } }), placeholder: '\u7528\u6237\u540D' }))
								),
								_react2.default.createElement(
										FormItem,
										null,
										getFieldDecorator('password', {
												rules: [{ required: true, message: '请输入密码!' }]
										})(_react2.default.createElement(_input2.default, { prefix: _react2.default.createElement(_icon2.default, { type: 'lock', style: { fontSize: 13 } }), type: 'password', placeholder: '\u5BC6\u7801' }))
								),
								_react2.default.createElement(
										FormItem,
										{ style: { display: showCaptcha ? 'block' : 'none' } },
										getFieldDecorator('captcha', {
												rules: [{ required: showCaptcha, message: '请输入验证码!', len: 4 }]
										})(_react2.default.createElement(_Captcha2.default, { isReSet: this.state.isReSet }))
								),
								_react2.default.createElement(
										FormItem,
										null,
										_react2.default.createElement(
												'a',
												{ className: 'login-form-forgot-link', href: 'javascript:;', onClick: this.showModal },
												'\u5FD8\u8BB0\u5BC6\u7801'
										),
										_react2.default.createElement(
												_button2.default,
												{ type: 'primary', htmlType: 'submit', className: 'login-form-button' },
												'\u767B\u5F55'
										)
								)
						),
						_react2.default.createElement(_forgetPasswordForm2.default, {
								className: 'login-form-forgot-modal',
								visible: this.state.visible,
								onCancel: this.handleCancel
						})
				);
		};

		return NormalLoginForm;
}(_react.Component);

NormalLoginForm.propTypes = {
		login: _react.PropTypes.func,
		getMobileCode: _react.PropTypes.func
};


var mapStateToProps = function mapStateToProps(_ref4) {
		var page = _ref4.page,
		    query = _ref4.query;
		var isLoginIng = page.isLoginIng;
		var _query$redirect_uri = query.redirect_uri,
		    redirect_uri = _query$redirect_uri === undefined ? '' : _query$redirect_uri,
		    _query$client_id = query.client_id,
		    client_id = _query$client_id === undefined ? '' : _query$client_id,
		    _query$state = query.state,
		    state = _query$state === undefined ? '' : _query$state;

		return {
				isLoginIng: isLoginIng,
				redirect_uri: redirect_uri,
				client_id: client_id,
				state: state
		};
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
		return {
				authorizationLogin: function authorizationLogin(params) {
						return dispatch((0, _login2.default)(params));
				},
				getMobileCode: function getMobileCode(params) {
						return dispatch((0, _getMobileCode3.default)(params));
				}
		};
};

var WrappedNormalLoginForm = _form2.default.create()(NormalLoginForm);

var _default7 = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(WrappedNormalLoginForm);

exports.default = _default7;
;

var _temp = function () {
		if (typeof __REACT_HOT_LOADER__ === 'undefined') {
				return;
		}

		__REACT_HOT_LOADER__.register(FormItem, 'FormItem', '/Users/liu/Documents/code/fancy_oa_web_frontend/src/components/authorization/index.js');

		__REACT_HOT_LOADER__.register(NormalLoginForm, 'NormalLoginForm', '/Users/liu/Documents/code/fancy_oa_web_frontend/src/components/authorization/index.js');

		__REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/liu/Documents/code/fancy_oa_web_frontend/src/components/authorization/index.js');

		__REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/liu/Documents/code/fancy_oa_web_frontend/src/components/authorization/index.js');

		__REACT_HOT_LOADER__.register(WrappedNormalLoginForm, 'WrappedNormalLoginForm', '/Users/liu/Documents/code/fancy_oa_web_frontend/src/components/authorization/index.js');

		__REACT_HOT_LOADER__.register(_default7, 'default', '/Users/liu/Documents/code/fancy_oa_web_frontend/src/components/authorization/index.js');
}();

;

/***/ }),

/***/ 1572:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(1405);

var _index2 = _interopRequireDefault(_index);

__webpack_require__(1367);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var loginPage = function (_Component) {
	_inherits(loginPage, _Component);

	function loginPage() {
		_classCallCheck(this, loginPage);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	loginPage.prototype.render = function render() {
		return _react2.default.createElement(
			'div',
			null,
			_react2.default.createElement(
				'section',
				{ id: 'components-form-demo-normal-login' },
				_react2.default.createElement(_index2.default, null)
			),
			_react2.default.createElement(
				'div',
				{ className: 'fancy-foot' },
				_react2.default.createElement(
					'div',
					{ className: 'container clearfix' },
					_react2.default.createElement(
						'div',
						{ className: 'fancy-foot-quick-link' },
						_react2.default.createElement(
							'span',
							null,
							'\u8054\u7CFB\u6211\u4EEC',
							_react2.default.createElement('i', { className: 'icon-tel' }),
							_react2.default.createElement(
								'span',
								{ className: 'tel-num' },
								'400-1520-118'
							),
							_react2.default.createElement('i', { className: 'icon-tel' }),
							_react2.default.createElement(
								'span',
								{ className: 'tel-num' },
								'021-68620117'
							)
						)
					),
					_react2.default.createElement(
						'p',
						{ className: 'fancy-foot-copyright' },
						'Copyright\xA9FancyDigital.All Rights reserved.'
					),
					_react2.default.createElement(
						'p',
						{ className: 'fancy-foot-copyright' },
						_react2.default.createElement(
							'a',
							{ href: 'http://www.miitbeian.gov.cn/' },
							'\u4EACICP\u590715031715\u53F7-2'
						)
					)
				)
			)
		);
	};

	return loginPage;
}(_react.Component);

var _default = loginPage;
exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(loginPage, 'loginPage', '/Users/liu/Documents/code/fancy_oa_web_frontend/src/container/authorization/indexPage.js');

	__REACT_HOT_LOADER__.register(_default, 'default', '/Users/liu/Documents/code/fancy_oa_web_frontend/src/container/authorization/indexPage.js');
}();

;

/***/ }),

/***/ 1642:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getReducer = __webpack_require__(65);

var _getReducer2 = _interopRequireDefault(_getReducer);

var _objectAssign = __webpack_require__(19);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _login = __webpack_require__(380);

var _captchaCreate = __webpack_require__(572);

var _captchaValidate = __webpack_require__(573);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function login() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
		isLoginIng: false
	};
	var action = arguments[1];

	switch (action.type) {
		case _login.LOGIN_LOGIN_REQUEST:
			return (0, _objectAssign2.default)({}, state, { isLoginIng: true });
		case _login.LOGIN_LOGIN_SUCCESS:
			return (0, _objectAssign2.default)({}, state, { isLoginIng: false });
		case _login.LOGIN_LOGIN_FAILURE:
			return (0, _objectAssign2.default)({}, state, { isLoginIng: false });
		// 获取验证码
		case _captchaCreate.CAPTCHA_CREATE_REQUEST:
			return (0, _objectAssign2.default)({}, state, {});
		case _captchaCreate.CAPTCHA_CREATE_SUCCESS:
			return (0, _objectAssign2.default)({}, state, {});
		case _captchaCreate.CAPTCHA_CREATE_FAILURE:
			return (0, _objectAssign2.default)({}, state, {});

		// 校验验证码
		case _captchaValidate.CAPTCHA_VALIDATE_REQUEST:
			return (0, _objectAssign2.default)({}, state, {});
		case _captchaValidate.CAPTCHA_VALIDATE_SUCCESS:
			return (0, _objectAssign2.default)({}, state, {});
		case _captchaValidate.CAPTCHA_VALIDATE_FAILURE:
			return (0, _objectAssign2.default)({}, state, {});

		default:
			return state;
	}
}

var _default = (0, _getReducer2.default)(login);

exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(login, 'login', '/Users/liu/Documents/code/fancy_oa_web_frontend/src/reducer/authorization/index.js');

	__REACT_HOT_LOADER__.register(_default, 'default', '/Users/liu/Documents/code/fancy_oa_web_frontend/src/reducer/authorization/index.js');
}();

;

/***/ }),

/***/ 2031:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(13);
module.exports = __webpack_require__(891);


/***/ }),

/***/ 891:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _renderToApp = __webpack_require__(38);

var _renderToApp2 = _interopRequireDefault(_renderToApp);

var _index = __webpack_require__(1642);

var _index2 = _interopRequireDefault(_index);

var _indexPage = __webpack_require__(1572);

var _indexPage2 = _interopRequireDefault(_indexPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var render = (0, _renderToApp2.default)(_index2.default); /* title: 登录授权 */


render(_indexPage2.default);
if (false) {
	module.hot.accept('../../container/authorization/indexPage', function () {
		var NextApp = require('../../container/authorization/indexPage').default;
		render(NextApp);
	});
}
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(render, 'render', '/Users/liu/Documents/code/fancy_oa_web_frontend/src/main/oauth/index.js');
}();

;

/***/ })

},[2031]);


// WEBPACK FOOTER //
// oauth/index_134d6a6decb34dc9ab91.js